import axios from "axios";
import routes from "./config";

import { decrypt, crypt } from "../components/Util/util";

function getToken() {
    return decrypt('token', localStorage.getItem("token"));
}

export const requests = (method, url, data, cb, errorCallback, content_type) => {

    const headers = { 'Content-Type': (content_type ? content_type : 'application/json') };

    if (content_type == 'multipart/form-data') {
        url = url + '?token=' + getToken();
    }

    if (getToken()) data.token = getToken();

    let config = { method, url, headers }

    if (method === 'get') config.params = data
    else config.data = data

    axios(config)
        .then(({ data }) => {

            let { error, message, status } = data;

            if (status == 1003) {
                autoSignInSubUser(null);
                return
            }

            if (!error) cb(message);
            else errorCallback(message);

        }).catch(({ message }) => {

            if (errorCallback) errorCallback(message);

            else console.log(message);

        });

};

export const get_configs = (body, cb, err) => {
    requests('get', routes.get_configs, body, cb, err);
}

export const check_email_req = (body, cb, err) => {
    requests('post', routes.check_email_req, body, cb, err);
}

export const verify_code = (body, cb, err) => {
    requests('get', routes.verify_code, body, cb, err);
}

export const sing_in = (body, cb, err) => {
    requests('post', routes.sing_in, body, cb, err);
}

export const login_guest_mode = (body, cb, err) => {
    requests('post', routes.login_guest_mode, body, cb, err);
}

export const forgot_password = (body, cb, err) => {
    requests('post', routes.forgot_password, body, cb, err);
}

export const change_password = (body, cb, err) => {
    requests('post', routes.change_password, body, cb, err);
}

export const validate_token = (body, cb, err) => {
    requests('post', routes.validate_token, body, cb, err)
}

export const sub_users = (body, cb, err) => {
    requests('post', routes.sub_users, body, cb, err)
}

export const get_user_by_id = (body, cb, err) => {
    requests('post', routes.get_user_by_id, body, cb, err)
}

export const create_sub_user = (body, cb, err) => {
    requests('post', routes.create_sub_user, body, cb, err)
}

export const verify_root = (body, cb, err) => {
    requests('post', routes.verify_root, body, cb, err)
}

export const get_highlighted = (body, cb, err) => {
    requests('get', routes.get_highlighted, body, cb, err)
}

export const get_home = (body, cb, err) => {
    requests("get", routes.get_home, body, cb, err)
}

export const search = (body, cb, err) => {
    requests('get', routes.search, body, cb, err)
}

export const get_channels = (body, cb, err) => {
    requests('get', routes.get_channels, body, cb, err)
}

export const get_categories = (body, cb, err) => {
    requests('post', routes.get_categories, body, cb, err)
}

export const get_lessons = (body, cb, err) => {
    requests('get', routes.get_lessons, body, cb, err)
}

export const get_movies = (body, cb, err) => {
    requests('get', routes.get_movies, body, cb, err)
}

export const get_series = (body, cb, err) => {
    requests('get', routes.get_series, body, cb, err)
}

export const get_favourites = (body, cb, err) => {
    requests('get', routes.get_favourites, body, cb, err)
}

export const get_movie_info = (body, cb, err) => {
    requests('get', routes.get_movie_info, body, cb, err)
}

export const get_related_movies = (body, cb, err) => {
    requests('get', routes.get_related_movies, body, cb, err)
}

export const get_day_epg = (body, cb, err) => {
    requests('post', routes.get_day_epg, body, cb, err)
}

export const add_channel_to_favourites = (body, cb, err) => {
    requests('post', routes.add_channel_to_favourites, body, cb, err)
}

export const remove_channel_from_favourites = (body, cb, err) => {
    requests('post', routes.remove_channel_from_favourites, body, cb, err)
}

export const add_movie_to_favourites = (body, cb, err) => {
    requests('post', routes.add_movie_to_favourites, body, cb, err)
}

export const remove_movie_from_favourites = (body, cb, err) => {
    requests('post', routes.remove_movie_from_favourites, body, cb, err)
}

export const remember_time = (body, cb, err) => {
    requests('post', routes.remember_time, body, cb, err)
}

export const register_user = (body, cb, err) => {
    requests('post', routes.register_user, body, cb, err)
}

export const get_profile = (body, cb, err) => {
    requests('post', routes.getByRootUserId, body, cb, err)
}

export const get_language = (body, cb, err) => {
    requests('get', routes.getLanguage, body, cb, err)
}

export const get_sub_images = (body, cb, err) => {
    requests('get', routes.get_sub_images, body, cb, err)
}

export const edit_profile = (body, cb, err) => {
    requests('post', routes.edit_profile, body, cb, err)
}

export const translated_words = (body, cb, err) => {
    requests('get', routes.translated_words, body, cb, err)
}

export const set_online = (body, cb, err) => {
    requests('post', routes.set_online, body, cb, err)
}

export const set_view_channels = (body, cb, err) => {
    requests('post', routes.set_view_channels, body, cb, err)
}

export const set_advertisement_req = (type, body, cb, err) => {
    requests('post', routes.set_advertisement(type), body, cb, err)
}

export const get_tariff = (body, cb, err) => {
    requests('post', routes.get_tariff, body, cb, err)
}

export const get_pricing_items = (body, cb, err) => {
    requests('get', routes.get_pricing_items, body, cb, err)
}

export const remove_watch_list = (body, cb, err) => {
    requests('delete', routes.remove_watch_list, body, cb, err)
}

export const subscribe = (body, cb, err) => {
    requests('post', routes.subscribe, body, cb, err)
}

export const get_payments = (body, cb, err) => {
    requests('get', routes.get_payments, body, cb, err)
}

export const get_payment_history = (body, cb, err) => {
    requests('get', routes.get_payment_history, body, cb, err)
}

export const authorize = (body, cb, err) => {
    requests('post', routes.authorize, body, cb, err)
}

export const get_stripe = (body, cb, err) => {
    requests('get', routes.get_stripe, body, cb, err)
}

export const resend_verify_email = (body, cb, err) => {
    requests('post', routes.resend_verify_email, body, cb, err)
}

export const rent_movie = (body, cb, err) => {
    requests('post', routes.rent_movie, body, cb, err)
}

export const buy_movie = (body, cb, err) => {
    requests('post', routes.buy_movie, body, cb, err)
}

export const get_app_url = (body, cb, err) => {
    requests('get', routes.get_app_url, body, cb, err)
}

export const get_movie_url = (body, cb, err) => {
    requests('get', routes.get_movie_url, body, cb, err)
}

export const get_question = (body, cb, err) => {
    requests('get', routes.get_question, body, cb, err)
}

export const get_question_answers = (body, cb, err) => {
    requests('post', routes.get_question_answers, body, cb, err)
}

export const get_messages = (body, cb, err) => {
    requests('get', routes.get_messages, body, cb, err)
}

export const get_not_read_messages_count = (body, cb, err) => {
    requests('get', routes.get_not_read_messages_count, body, cb, err)
}

export const send_message = (type, body, cb, err) => {

    let content_type = 'application/json'

    if (type === 'file') content_type = 'multipart/form-data'

    requests('post', routes.send_message(type), body, cb, err, content_type)
}

export const autoSignInSubUser = (router, onSuccess, onError) => {
    sessionStorage.setItem('auto_signing_in', '1');

    const clearAutoSignIn = () => sessionStorage.removeItem('auto_signing_in');

    const goHome = () => {
        clearAutoSignIn();
        if (onSuccess) onSuccess();
        else if (router) router.push('/');
        else window.location.href = '/#/';
    };

    const goSubUsers = () => {
        clearAutoSignIn();
        if (router) router.push('/subusers');
        else window.location.href = '/#/subusers';
    };

    const attemptVerify = (subUser, password, onFail) => {
        verify_root(
            { password, id: subUser.id },
            (token) => {
                localStorage.setItem('token', crypt('token', token));
                goHome();
            },
            onFail
        );
    };

    sub_users({}, (data) => {
        if (!data?.length) {
            goSubUsers();
            return;
        }

        const subUser = data[0];
        localStorage.setItem('root_id', subUser.id);
        localStorage.setItem('user', crypt('user', JSON.stringify(subUser)));

        if (data.length > 1) {
            goSubUsers();
            return;
        }

        attemptVerify(subUser, subUser.password || '', (err) => {
            attemptVerify(subUser, '', (err) => {
                clearAutoSignIn();
                if (onError) onError(err);
                else goSubUsers();
            });
        });
    }, (err) => {
        clearAutoSignIn();
        if (err === 'User not found') {
            const device_id = localStorage.getItem('device_id');
            localStorage.clear();
            localStorage.setItem('device_id', device_id);
            if (router) router.push('/auth');
            else window.location.href = '/#/auth';
        } else if (onError) {
            onError(err);
        } else {
            goSubUsers();
        }
    });
};
